module.exports = __webpack_public_path__ + "14c86337f75961d75baedf1ac4fa8059.svg";